import { render } from "./AdminProduct.vue?vue&type=template&id=7db7066a&scoped=true"
import script from "./AdminProduct.vue?vue&type=script&lang=js"
export * from "./AdminProduct.vue?vue&type=script&lang=js"

import "./AdminProduct.vue?vue&type=style&index=0&id=7db7066a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db7066a"]])

export default __exports__